import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb2a3e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pIconInfo.imgPath && !_ctx.pIconInfo.isCircle)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["iconStyle commonSmallText fontBold", {
      pointBG: _ctx.pIconInfo.pointYn,
      noBorderIcon: _ctx.pIconInfo.noBorder,
      imgBox: _ctx.pIconInfo.imgPath,
    }])
      }, [
        _createElementVNode("img", {
          src: _ctx.pIconInfo.imgPath,
          alt: _ctx.pIconInfo.iconText
        }, null, 8, _hoisted_1),
        _createElementVNode("p", null, _toDisplayString(_ctx.pIconInfo.iconText ? _ctx.pIconInfo.iconText : '-'), 1)
      ], 2))
    : (_ctx.pIconInfo.isCircle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["iconStyle commonSmallText fontBold", {
      pointBG: _ctx.pIconInfo.pointYn,
      noBorderIcon: _ctx.pIconInfo.noBorder,
      circleIcon: _ctx.pIconInfo.isCircle,
    }])
        }, [
          (_ctx.pIconInfo.imgPath)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.pIconInfo.imgPath,
                alt: _ctx.pIconInfo.title
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.pIconInfo.iconText ? _ctx.pIconInfo.iconText : '-'), 1))
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["iconStyle normalIcon commonSmallText fontBold", {
      pointBG: _ctx.pIconInfo.pointYn,
      noBorderIcon: _ctx.pIconInfo.noBorder,
    }])
        }, _toDisplayString(_ctx.pIconInfo.iconText ? _ctx.pIconInfo.iconText : '-'), 3))
}